import { CPT_COMPLETE } from './ActionTypes'

export function cptComplete(data) {
	return {
		type: CPT_COMPLETE,
		data: data
	}
} 